/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnswerRequest } from './answer-request';
import { DeckPitchSimpleRequest } from './deck-pitch-simple-request';
import { UserRequest } from './user-request';

export interface DeckQuestionRequest {
  pitch: DeckPitchSimpleRequest;
  user: UserRequest;
  text: string;
  muted?: boolean;
  answer: AnswerRequest;
}
